import { Box, Button, Stack, Typography } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { getAppStoreAppUrl } from 'shared/utils/externalUrls';

import { APP_CONFIG } from '@/constants/appConfig';
import { OPERATING_SYSTEM } from '@/constants/device';
import { getMobileOperatingSystem } from '@/utils/device';

const STORE_REDIRECT_ATTEMPTED_KEY = 'equinetStoreRedirectAttempted';

function GetMobileAppCallbackPage() {
    const { t } = useTranslation();
    const [params] = useSearchParams();
    const [hasRedirected, setHasRedirected] = useState(false);
    const mobileOS = getMobileOperatingSystem();
    const userRegionCode = params.get('region');

    const iosStoreUrl = useMemo(
        () =>
            userRegionCode
                ? getAppStoreAppUrl(userRegionCode)
                : APP_CONFIG.iosStoreUrl,
        [userRegionCode],
    );
    const automaticStoreUrl =
        mobileOS === OPERATING_SYSTEM.android
            ? APP_CONFIG.androidStoreUrl
            : mobileOS === OPERATING_SYSTEM.iOS
            ? iosStoreUrl
            : null;

    useEffect(() => {
        if (!automaticStoreUrl) return;

        const hasAttemptedRedirect =
            window.sessionStorage.getItem(STORE_REDIRECT_ATTEMPTED_KEY) ===
            'true';
        if (hasAttemptedRedirect) return;

        window.sessionStorage.setItem(STORE_REDIRECT_ATTEMPTED_KEY, 'true');
        setHasRedirected(true);
        window.location.replace(automaticStoreUrl);
    }, [automaticStoreUrl]);

    return (
        <Box
            sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                minHeight: '100vh',
                px: 3,
                textAlign: 'center',
            }}
        >
            <Stack maxWidth={480} spacing={3}>
                <Typography variant="h4">EQUINET</Typography>
                <Typography>
                    {hasRedirected && automaticStoreUrl
                        ? t('GetMobileAppPage:text', {
                              store:
                                  mobileOS === OPERATING_SYSTEM.iOS
                                      ? 'App Store'
                                      : 'Google Play',
                          })
                        : 'Install the EQUINET app to continue.'}
                </Typography>
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent="center"
                    spacing={2}
                >
                    <Button
                        href={APP_CONFIG.androidStoreUrl}
                        rel="noreferrer"
                        target="_blank"
                        variant="contained"
                    >
                        Google Play
                    </Button>
                    <Button
                        href={iosStoreUrl}
                        rel="noreferrer"
                        target="_blank"
                        variant="outlined"
                    >
                        App Store
                    </Button>
                </Stack>
            </Stack>
        </Box>
    );
}

export default GetMobileAppCallbackPage;
